import { ITest, LabelPosition, RHookFormMaskedTextFieldWithLabel, RHookFormTextFieldWithLabel } from "@websential/cosmic";

import { FC } from "react";
import { Grid } from "@mui/material";

interface IRL1SettingsPanel extends ITest { }

export const RL1SettingsPanel: FC<IRL1SettingsPanel> = ({ testId }) => {
  return (
    <Grid
      container
      columnSpacing={6}
      rowSpacing={2}
      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
    >
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="CNT Rate (%)"
          id="rl1SettingsCntRatePercentage"
          testId={`${testId}-cnt-rate-percentage`}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Second CNT Rate (%)"
          id="rl1SettingsSecondCntRatePercentage"
          testId={`${testId}-cnt-rate-percentage`}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="WSDRF Rate (%)"
          id="rl1SettingsWsdrfRatePercentage"
          testId={`${testId}-wsdrf-rate-percentage`}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormMaskedTextFieldWithLabel
          label="Certification No"
          id="certificationNoRl1"
          testId={`${testId}-certificationNoRl1`}
          labelPosition={LabelPosition.Top}
          placeholder={"RQ-00-00-000"}
          inputMaskPattern={"aa-00-00-000"}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormMaskedTextFieldWithLabel
          label="Authentication No"
          id="authenticationNoRl1"
          testId={`${testId}-authenticationNoRl1`}
          labelPosition={LabelPosition.Top}
          placeholder={"FS 0000000"}
          inputMaskPattern={"FS 0000000"}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Barcode Initial"
          id="barcodeInitialRl1"
          testId={`${testId}-barcodeInitialRl1`}
          labelPosition={LabelPosition.Top}
        // placeholder={"RQ-00-00-000"}
        // inputMaskPattern={"aa-00-00-000"}
        />
      </Grid>
    </Grid>
  );
};
